export default "__VITE_ASSET__0c4b8b5f__"